module.exports = __webpack_public_path__ + "static/img/1.dd49ecb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1.jpg
// module id = dE1y
// module chunks = 136